import React, { useEffect } from 'react';
import { X, AlertCircle, CheckCircle2, Info } from 'lucide-react';
import { alert } from '../ui/uiTheme';

const ICONS = {
  error: AlertCircle,
  success: CheckCircle2,
  info: Info,
};

const STYLES = {
  error: `${alert.error} border`,
  success: `${alert.success} border`,
  info: `${alert.info} border`,
};

export function ToastItem({ id, type, message, duration, onDismiss }: any) {
  const Icon = ICONS[type] || Info;
  const style = STYLES[type] || STYLES.info;

  useEffect(() => {
    if (duration > 0) {
      const t = setTimeout(() => onDismiss(id), duration);
      return () => clearTimeout(t);
    }
  }, [id, duration, onDismiss]);

  return (
    <div
      role="alert"
      className={`flex items-start gap-3 rounded-lg border px-4 py-3 shadow-lg ${style}`}
    >
      <Icon className="h-5 w-5 flex-shrink-0 mt-0.5" />
      <p className="flex-1 text-sm font-medium break-words">{message}</p>
      <button
        type="button"
        onClick={() => onDismiss(id)}
        className="flex-shrink-0 p-1 rounded bg-dark-surface/5 hover:bg-dark-surface/15 transition-colors"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}

export function ToastContainer({ toasts, onDismiss }: any) {
  return (
    <div
      className="fixed top-4 right-4 z-[200] flex flex-col gap-2 max-w-md w-full pointer-events-none"
      aria-live="polite"
    >
      <div className="flex flex-col gap-2 pointer-events-auto">
        {toasts.map((t) => (
          <ToastItem
            key={t.id}
            id={t.id}
            type={t.type}
            message={t.message}
            duration={t.duration}
            onDismiss={onDismiss}
          />
        ))}
      </div>
    </div>
  );
}
